import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import MatchingStore from '@App/stores/rightsholder/match/matching-store'
import { MatchingToolLocationState, PreselectedMatchWork } from '@Entities/matching/preselected-match-work'

const usePreselectedMatchWork = (
    matchingStore: MatchingStore,
    runSearch: (preselectedWork: PreselectedMatchWork) => void
) => {
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        const preselectedWork = (location.state as MatchingToolLocationState | null)?.matchWork
        if (!preselectedWork) {
            return
        }

        matchingStore.setPreselectedWork(preselectedWork)
        navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: null })
        runSearch(preselectedWork)
    }, [])
}

export default usePreselectedMatchWork
